import { apiOpenPDF } from '../api/api-utils';
import { getServiceRequestInstructions } from '../api/service-request-api';
import { IAccount, IAccountUpper } from './company-account';
import { IOracleDevice } from './device';

export const getServiceRequestInitial = (
    action: string
): IServiceRequestInitial => {
    return {
        repairs: null,
        returns: null,
        exchanges: [getColorExchangeInitial()],
        billTo: {
            AccountNumber: '',
            FullAccountNumber: '',
            PartyName: '',
        },
        shipTo: {
            Id: '',
            AccountNumber: '',
            AccountAddress: '',
            FullAccountNumber: '',
            FullAddress: '',
            Location: '',
            LocationId: '',
            CustomerId: undefined,
            PartyId: 0,
            PartyName: '',
            PhoneNumber: '',
            Region: '',
            CustomerCategory: '',
            EstoreEligible: undefined,
            PoRequiredTypes: [],
            ConsignmentAllowed: undefined,
            ConsignmentFlag: '',
            ConsignmentLevel: '',
            OrderTypes: [],
            SopPoRequiredCustom: '',
            SopPoRequiredEarmold: '',
            SopPoRequiredMisc: '',
            SopPoRequiredStandard: '',
            Street1: '',
            Street2: '',
            Street3: '',
            Street4: '',
            City: '',
            State: '',
            PostalCode: '',
            Country: '',
        },
        contactName: '',
        contactPhone: '',
        poNumber: '',
        referenceNumber: '',
        serviceOption: '',
        shippingOption: '',
        shippingLabel: false,
        lithiumLabel: false,
        boxNumbers: [],
    };
};

export const getColorExchangeInitial = (): IServiceRequestExchanges => {
    return {
        authorization1: undefined,
        authorization2: undefined,
        batteryOption: undefined,
        comments: undefined,
        description: undefined,
        devices: [
            { category: 'Serial # 1', name: '' },
            { category: 'Patient Name # 1', name: '' },
            { category: 'Description # 1', name: '' },
        ],
        firstName: '',
        fitIssuePatientComments: undefined,
        issueId: undefined,
        issues: [{ category: 'New Color', name: '' }],
        lastName: '',
        manufacturer: undefined,
        model: '',
        newColor: '',
        patientName: undefined,
        serialNumber1: '',
        serialNumber2: undefined,
        servicePlan: undefined,
    };
};

export const getShipToDropShipInitial = (
    fullAccountNumber: string,
    country: string
): IAccountDropShip => {
    return {
        FullAccountNumber: fullAccountNumber,
        IsDropShip: true,
        Street1: '',
        Street2: '',
        City: '',
        State: '',
        PostalCode: '',
        Country: country,
        PoRequiredTypes: null,
    };
};

export const getShipToUpper = (shipTo: IAccount): IAccountUpper => ({
    Id: shipTo.id,
    AccountNumber: shipTo.accountNumber,
    AccountAddress: shipTo.accountAddress,
    FullAccountNumber: shipTo.fullAccountNumber,
    FullAddress: shipTo.fullAddress,
    Location: shipTo.location,
    LocationId: shipTo.locationId,
    CustomerId: shipTo.customerId,
    PartyId: shipTo.partyId,
    PartyName: shipTo.partyName,
    PhoneNumber: shipTo.phoneNumber,
    Region: shipTo.region,
    CustomerCategory: shipTo.customerCategory,
    EstoreEligible: shipTo.estoreEligible,
    PoRequiredTypes: shipTo.poRequiredTypes,
    ConsignmentAllowed: shipTo.consignmentAllowed,
    ConsignmentFlag: shipTo.consignmentFlag,
    ConsignmentLevel: shipTo.consignmentLevel,
    OrderTypes: shipTo.orderTypes,
    SopPoRequiredCustom: shipTo.sopPoRequiredCustom,
    SopPoRequiredEarmold: shipTo.sopPoRequiredEarmold,
    SopPoRequiredMisc: shipTo.sopPoRequiredMisc,
    SopPoRequiredStandard: shipTo.sopPoRequiredStandard,
    Street1: shipTo.street1,
    Street2: shipTo.street2,
    Street3: shipTo.street3,
    Street4: shipTo.street4,
    City: shipTo.city,
    State: shipTo.state,
    PostalCode: shipTo.postalCode,
    Country: shipTo.country,
});

export const getSerialNumberInitial = (): ISerialNumber => {
    return {
        SN1: '',
        RN1: '',
        SN1changed: false,
        device1: undefined,
        pairDevice1: undefined,
        error1: '',
        warning1: '',
        SN2: '',
        RN2: '',
        SN2changed: false,
        device2: undefined,
        error2: '',
        warning2: '',
        colors: [],
        newColor: '',
        patient1First: '',
        patient1Last: '',
        patient2First: '',
        patient2Last: '',
    };
};

export const mapColorExchageStateToServiceRequest = (
    colorExchangeState: ISerialNumber[],
    serviceRequest: IServiceRequestInitial
) => {
    const mappedExchanges = serviceRequest.exchanges.map((objSR, i) => ({
        ...objSR,
        serialNumber1: colorExchangeState[i].SN1
            ? colorExchangeState[i].SN1
            : objSR.serialNumber1,
        serialNumber2: colorExchangeState[i].SN2
            ? colorExchangeState[i].SN2
            : objSR.serialNumber2,
        authorization1: colorExchangeState[i].RN1
            ? colorExchangeState[i].RN1
            : objSR.authorization1,
        authorization2: colorExchangeState[i].RN2
            ? colorExchangeState[i].RN2
            : objSR.authorization2,
        firstName: colorExchangeState[i].patient1First
            ? colorExchangeState[i].patient1First
            : objSR.firstName,
        lastName: colorExchangeState[i].patient1Last
            ? colorExchangeState[i].patient1Last
            : objSR.lastName,
        model: colorExchangeState[i].device1
            ? colorExchangeState[i].device1!.hearingAidType
            : objSR.model,
        newColor: colorExchangeState[i].newColor
            ? colorExchangeState[i].newColor
            : objSR.newColor,
        manufacturer: colorExchangeState[i].device1
            ? colorExchangeState[i].device1!.manufacturer
            : objSR.manufacturer,
        issues: [
            {
                category: 'New Color',
                name: colorExchangeState[i].newColor
                    ? colorExchangeState[i].newColor
                    : objSR.issues[0].name,
            },
        ],
        devices: [
            {
                category: 'Serial # 1',
                name: colorExchangeState[i].SN1
                    ? colorExchangeState[i].SN1
                    : '',
            },
            {
                category: 'Patient Name # 1',
                name:
                    (colorExchangeState[i].device1 &&
                        colorExchangeState[i].device1!.hearingAidType &&
                        colorExchangeState[i].patient1First) ||
                    colorExchangeState[i].patient1Last
                        ? colorExchangeState[i].patient1First +
                          colorExchangeState[i].patient1Last
                        : '',
            },
            {
                category: 'Description # 1',
                name: colorExchangeState[i].device1
                    ? colorExchangeState[i].device1!.hearingAidType
                    : '',
            },
            {
                category: 'Serial # 2',
                name: colorExchangeState[i].SN2
                    ? colorExchangeState[i].SN2
                    : undefined,
            },
            {
                category: 'Patient Name # 2',
                name:
                    (colorExchangeState[i].device2 &&
                        colorExchangeState[i].device2!.hearingAidType &&
                        colorExchangeState[i].patient2First) ||
                    colorExchangeState[i].patient2Last
                        ? colorExchangeState[i].patient2First +
                          colorExchangeState[i].patient2Last
                        : undefined,
            },
            {
                category: 'Description # 2',
                name: colorExchangeState[i].device2
                    ? colorExchangeState[i].device2!.hearingAidType
                    : undefined,
            },
        ] as IDevicesAndIssues[],
    }));

    serviceRequest.exchanges = mappedExchanges;
    serviceRequest.contactPhone = serviceRequest.contactPhone.replaceAll(
        /[^0-9]/g,
        ''
    );

    return serviceRequest;
};

export interface IServiceRequestInitial {
    repairs: null;
    returns: null;
    exchanges: IServiceRequestExchanges[];
    billTo: IServiceRequestBillTo;
    shipTo: IAccountUpper | IAccountDropShip;
    contactName: string;
    contactPhone: string;
    poNumber: string;
    referenceNumber: string;
    serviceOption: string;
    shippingOption: string;
    shippingLabel: boolean;
    lithiumLabel: boolean;
    boxNumbers: string[];
}

export interface IServiceRequestExchanges {
    authorization1?: string;
    authorization2?: string;
    batteryOption?: boolean;
    comments?: string;
    description?: string;
    devices: IDevicesAndIssues[];
    firstName: string;
    fitIssuePatientComments?: string;
    issueId?: string;
    issues: IDevicesAndIssues[];
    lastName: string;
    manufacturer?: string;
    model: string;
    newColor: string;
    patientName?: string;
    serialNumber1: string;
    serialNumber2?: string;
    servicePlan?: string;
}

export interface IAccountDropShip {
    FullAccountNumber: string;
    IsDropShip: boolean;
    Street1: string;
    Street2: string;
    City: string;
    State: string;
    PostalCode: string;
    Country: string;
    PoRequiredTypes: string[] | null;
}

export interface IDevicesAndIssues {
    category: string;
    name: string;
}

export interface IServiceRequestBillTo {
    AccountNumber: string;
    FullAccountNumber: string;
    PartyName: string;
}

export interface IServiceRequestOptions {
    text: string;
    value: string;
    url?: string;
}

export interface IServiceOptions {
    Body: string[];
    Message: string | null;
    Response: number;
}

export interface IServicePartNumberOptions {
    Body: IPartNumberOptions[];
    Message: string | null;
    Response: number;
}

export interface IPartNumberOptions {
    id: number;
    type: number;
    name: string;
}

export interface ISerialNumber {
    SN1: string;
    RN1: string;
    SN1changed: boolean;
    device1?: IOracleDevice;
    pairDevice1?: IOracleDevice;
    error1: string;
    warning1: string;
    SN2: string;
    RN2: string;
    SN2changed: boolean;
    device2?: IOracleDevice;
    error2: string;
    warning2: string;
    colors: IServiceRequestOptions[];
    newColor: string;
    patient1First: string;
    patient1Last: string;
    patient2First: string;
    patient2Last: string;
}

export interface IErrorSNState {
    [key: number]: boolean | null;
}

export const openServiceRequestInstructions = async (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
) => {
    e.preventDefault();
    const result = await getServiceRequestInstructions();
    apiOpenPDF(result);
};
